export const chartDefaultColors = ["#36A2EB", "#FFCE56", "#FF6384", "#fff"];